import React, {Component} from 'react';
import {AlertDanger} from '@homeaway/react-alerts';

class ErrorViewComponent extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let content = '';
        if (this.props.error !== '') {
            content = (<AlertDanger title={this.props.errorTitle} msg={this.props.error} svg="svg-alert-danger" />);
        }
        return (
            <React.Fragment>
                {content}
            </React.Fragment>
        );
    }
}

export default ErrorViewComponent;
